import moment from 'moment';
import { useMemo } from 'react';
import { REPORT_NAMES } from '../../components/reports/constants/report-names.constants';
import { useDataProvider } from '../data-provider/data-provider.hook';
import { FilterSelectedValue } from '../filters/interfaces/filter-selected-value.interface';
export const useLastAvailableDate = (
  filterSelection: FilterSelectedValue[],
  reportId = REPORT_NAMES.FILTER_REFRESH_INFO,
  enabled = true,
) => {
  const { data } = useDataProvider<any>(reportId, filterSelection, [], enabled);
  const lastAvailableDate = useMemo(() => {
    if (data && data.rows.length > 0) {
      const lastUpdatedValue = moment(data.rows[0].WEEK).toDate();
      return lastUpdatedValue;
    }
    return undefined;
  }, [data]);
  return lastAvailableDate;
};
